<!-- Selected-options recap -->
<ion-list lines="full" class="quote-recap-list bg-transparent p-0 m-0">
  @for(section of recapSections(); track section.title) {
  <div class="recap-section py-2">
    <div class="recap-title fw-semibold mb-2">{{ section.title }}</div>
    @for(item of section.items; track item.label) {
    <div class="recap-row py-2">
      <div class="d-flex justify-content-between align-items-start gap-3">
        <div class="flex-grow-1">
          @if(item.badge) {
          <span class="badge rounded-pill" [ngClass]="item.badgeClass">{{ item.badge }}</span>
          } @else {
          <div class="recap-label">{{ item.label }}</div>
          }
          @if(item.description) {
          <div class="recap-description mt-1">{{ item.description }}</div>
          }
        </div>
        <div class="recap-price text-nowrap">{{ item.price | currency:'GBP' }}</div>
      </div>
    </div>
    }
  </div>
  }
</ion-list>

<!-- Vehicle spec detail sections -->
@if(details()?.length) {
<ion-list lines="full" class="quote-recap-list bg-transparent p-0 m-0 mt-2">
  @for(section of details(); track $index) {
  <div class="recap-section py-2">
    <div class="recap-title fw-semibold mb-2">{{ section.section | translate }}</div>
    @for(row of section.rows; track $index) {
    @if(row.value !== null && row.value !== undefined && row.value !== '') {
    <div class="recap-row py-2">
      <div class="d-flex justify-content-between align-items-start gap-3">
        <div class="recap-description">{{ row.key | translate }}</div>
        <div class="recap-label text-nowrap">{{ row.value }}</div>
      </div>
    </div>
    }
    }
  </div>
  }
</ion-list>
}
